<template>
    <div
        class="choose-input"
        :class="{'validate-error':!validateResult,readonly:readonly,invisible:invisible}"
        @mousedown.stop
        @dblclick="dblclickHandle"
        @click="clickHandle"
    >
        <div v-if="readonly || invisible" class="readonly-text">{{value}}</div>
        <template v-else>
            <input :name="options.field" :value="value" :readonly="editable" />
            <div class="choose-input-icon" @click="choose">
                <editImg v-bind="{color:'#666666',width:'16px',height:'16px'}" />
            </div>
        </template>
    </div>
</template>
<script>
import Gikam from "../../../../core/gikam-core";
import Vue from "vue";
import jQuery from "jquery";
import Cron from "./cronPicker.vue";

export default {
    props: {
        options: Object,
        propValue: String,
        rowIndex: Number,
        //编辑器中的边框等样式是否显示出来
        propInvisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            validateResult: true,
            readonly: this.options.readonly,
            field: this.options.field,
            value: this.propValue,
            invisible: this.propInvisible
        };
    },

    computed: {
        editable() {
            return this.options.editable === true ? "" : "readonly";
        }
    },

    watch: {
        value() {
            this.$emit("change", this.options.field, this.value, this.rowIndex);
        },
        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        trigger(event, data) {
            let listener = this.options["on" + Gikam.toInitialUpperCase(event)];
            if (listener) {
                return listener.call(this.parent, data, this.rowIndex);
            }
        },

        choose() {
            let modal = Gikam.create("modal", {
                title: "Cron表达式",
                width: 900
            });

            let _this = this;

            let cronPicker = new Vue({
                el: jQuery(
                    "<Cron ref='cronView' :value='value' @change='change' @modalclose='modalClose'></Cron>"
                ).appendTo(modal.window.$dom)[0],
                components: {
                    Cron
                },
                data() {
                    return {
                        value: _this.value
                    };
                },
                methods: {
                    modalClose() {
                        modal.close();
                    },

                    change(value) {
                        _this.value = value;
                        this.createCronDesc(value).done(desc => {
                            if (_this.options.onAfterChoose) {
                                _this.options.onAfterChoose.call(_this, desc);
                            }
                        });
                    },

                    getCronDesc(value) {
                        return Gikam.postText(
                            Gikam.IFM_CONTEXT + "/core/module/sys/crons/descs",
                            Gikam.getJsonWrapper({ cron: value })
                        );
                    }
                }
            });
            Gikam.create("layout", {
                renderTo: modal.window.$dom,
                center: {
                    items: [
                        {
                            type: "btnToolbar",
                            items: [
                                {
                                    type: "button",
                                    text: "取消",
                                    onClick() {
                                        modal.close();
                                    }
                                },
                                {
                                    type: "button",
                                    text: "确定",
                                    class: "blue",
                                    onClick() {
                                        _this.value =
                                            cronPicker.$refs.cronView.cronExpression;
                                        modal.close();
                                    }
                                }
                            ]
                        }
                    ]
                }
            });
        },

        dblclickHandle() {
            this.$emit("dblclick", this);
        },

        clickHandle() {
            this.$emit("click", this);
        }
    }
};
</script>

<style scoped>
.choose-input {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
}

.choose-input input,
.choose-input .readonly-text {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-right: 40px;
    padding-left: 10px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
}

.choose-input .readonly-text {
    background-color: #f4f4f4;
    color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
}

.choose-input input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.choose-input.validate-error input {
    border-color: #ff6e6e;
}

.choose-input .choose-input-icon {
    width: 30px;
    cursor: pointer;
    margin-left: -30px;
    background-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.invisible .readonly-text {
    background-color: transparent;
    border: none;
}
</style>